import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { CreditNoteListComponent } from './list/credit-note-list.component';
import { CreditNoteRestService } from './credit-note-rest.service';
import { CreditNoteRoutingModule } from './credit-note-routing.module';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { BaseModule } from '../../libraries/base/base.module';
import { AddModalComponent } from './add-modal/add-modal.component';
import { DrawerComponent } from '../../libraries/drawer/drawer.component';
import { DetailModalComponent } from './detail-modal/detail-modal.component';
import { ModalComponent } from '../../libraries/modal/modal.component';

export const PROVIDERS = [CreditNoteRestService];

@NgModule({
  imports: [
    CreditNoteRoutingModule,
    BaseModule,
    BsDropdownModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule,
    ButtonModule,
    DialogModule
  ],
  declarations: [CreditNoteListComponent, DrawerComponent, ModalComponent, AddModalComponent, DetailModalComponent]
})
export class CreditNoteModule {}
